import { withChartLayout } from 'components/common';
import ObstetricHistory from 'components/features/chart/provider-chart/history-physical/obstetric-history/ObstetricHistory';

const ObstetricHistoryPage = withChartLayout('Obstetric History')(ObstetricHistory);
export default ObstetricHistoryPage;
